/* eslint-disable max-len */
export default {
  title: '信息安全基本方针',
  desc: '飞狼*，秉持对设计和技术的追求，通过精心打磨每一个细节的产品，致力于为用户带来极致体验。\n'
      + '飞狼*，为了成为能够赢得客户和社会信赖的可持续发展企业，决定适当保护公司所拥有的信息资产，防止信息的丢失、盗窃、不正当使用和泄露，并为此依据条款引入信息安全管理体系。我们将信息安全管理作为经营上的最重要课题之一，为此制定了信息安全基本方针，以维护和提高信息安全，作为业务活动中的重要使命。',
  signature: '*飞狼是中国国内集团企业（成都市飞狼科技有限公司、大连飞狼科技有限公司、飞狼数码（上海）有限公司）的统一名称。',
  list: [
    {
      title: '建立信息安全体制',
      desc: '我们将建立、实施、维护和持续改进信息安全管理体系，提升信息安全。',
    },
    {
      title: '信息资产的管理和保护',
      desc: '我们将采用系统化的风险管理方法，识别、评估和处理信息安全风险，确保信息资产的保护。',
    },
    {
      title: '信息安全教育',
      desc: '我们将定期开展信息安全培训和意识活动，确保所有员工了解其在保护信息资产方面的角色和责任，确保产品和服务的安全性，保护客户和业务合作伙伴信息，以及公司的技术信息等重要信息。',
    },
    {
      title: '遵守法律法规',
      desc: '我们将遵守开展业务所在的国家和地区所适用的信息安全相关法律法规，以及与客户和业务合作伙伴签订的合同。',
    },
    {
      title: '持续改进',
      desc: '我们承诺通过定期审查和评估信息安全管理体系的绩效，识别改善机会，持续提升信息安全管理水平。',
    },
  ],
};
